//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'searchOrder',
  components: {
  },
  data () {
    return {
      id:0,
      code:'',
      order:{
        log:[],
        factory:[],
        community:{}
      },
    }
  },
  created(){
    this.config();
  },
  mounted(){
    this.code = this.$route.params.code;
    if(this.code){
        this.getOrder();
    }
    // this.changePop();
  
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    scanQRCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ["qrCode",'barCode'],
            success: function (res) {
                setTimeout(()=>{
                    // that.formData[id] = res.resultStr.split(',')[1];
                    if(res.resultStr.indexOf(",") != -1){
                      that.code = res.resultStr.split(',')[1];
                    }else{
                      that.code = res.resultStr;
                    }
                    that.getOrder();
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
    showPic(urls,url){
      wx.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder(){
      let that = this;
      if(!this.code){
        that.$func.showToast('订单号无效');
        return ;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.searchOrder({order_no:this.code,status:6}).then((res)=>{
        if(res){
          that.order = res.data;
          that.$func.endLoading();
        } 
      })  
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/searchOrder.vue